import { FC } from "react";
import { Content, isFilled } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { cn } from "@/lib/utils";
import { Albert_Sans, Pacifico } from "next/font/google";

const albert = Albert_Sans({
  subsets: ["latin"],
  weight: "400",
});

const alex = Pacifico({
  subsets: ["latin"],
  weight: "400",
});

export type HighlightProps = SliceComponentProps<Content.HighlightSlice>;

const Highlight: FC<HighlightProps> = ({ slice }) => {
  const { content, sign_text } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={cn("text-dark-primary px bg-[#F7F9F980] px-9 py-16 sm:py-20 md:py-32 lg:py-44", albert.className)}
    >
      <figure className="mx-auto max-w-[1316px] space-y-8 md:space-y-5">
        {isFilled.richText(content) && (
          <PrismicRichText
            field={content}
            components={{
              paragraph: ({ children }) => (
                <blockquote cite="#" className="leading-body-md text-center text-2xl md:text-3xl lg:text-4xl">
                  {children}
                </blockquote>
              ),
              em: ({ children }) => <em className="font-playfair font-medium">{children}</em>,
              strong: ({ children }) => <strong className="font-cabinet-grotesk font-bold">{children}</strong>,
            }}
          />
        )}
        {isFilled.keyText(sign_text) && (
          <figcaption className={cn("text-center text-xl italic", alex.className)}>{sign_text}</figcaption>
        )}{" "}
      </figure>
    </section>
  );
};

export default Highlight;
